module.exports = __webpack_public_path__ + "fonts/Antarctica-VF.97686213.ttf";